export default __webpack_public_path__ + "static/media/aenj.916abaa2.svg";